
export class QRCodePixDinamico {
    constructor() { }

    public imagemBRCode: string;
    public brCode: string;
    public numeroPedido: string;
    public codigoBRCode: string;
}
